/**
 * Dashboard Sidebar
 * Responsive sidebar with desktop and mobile variants
 *
 * Architecture:
 * - Desktop: Collapsible with expand/collapse toggle
 * - Tablet: Collapsed by default with flyout submenus
 * - Mobile: Hidden, opens as drawer overlay
 */

import { DesktopSidebar, MobileSidebar } from './components'

export function DashboardSidebar() {
  return (
    <>
      <DesktopSidebar />
      <MobileSidebar />
    </>
  )
}

// Re-export types for external use
export type { MenuItem, MenuGroup, SidebarContentProps } from './types'

// Re-export constants for customization
export {
  MAIN_MENU_ITEMS,
  MENU_GROUPS,
  SECONDARY_MENU_ITEMS,
  BOTTOM_MENU_ITEMS,
  SIDEBAR_DIMENSIONS,
} from './constants'
